import { render, staticRenderFns } from "./assign_modal.vue?vue&type=template&id=4ffd7d01&scoped=true&"
import script from "./assign_modal.vue?vue&type=script&lang=js&"
export * from "./assign_modal.vue?vue&type=script&lang=js&"
import style0 from "./assign_modal.vue?vue&type=style&index=0&id=4ffd7d01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd7d01",
  null
  
)

export default component.exports